import { render, staticRenderFns } from "./KidsfoundationLogoColorSecondary.vue?vue&type=template&id=dfa28e8e&"
import script from "./KidsfoundationLogoColorSecondary.vue?vue&type=script&lang=js&"
export * from "./KidsfoundationLogoColorSecondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports